var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiniLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 38,
    viewBox: "0 0 46 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0867 0H32.8558C34.7081 0 36.2237 1.5098 36.2237 3.35489V34.6451C36.2237 36.4902 34.7081 38 32.8558 38H10.0867C8.23441 38 6.71875 36.4902 6.71875 34.6451V3.35489C6.71875 1.5098 8.23441 0 10.0867 0Z",
    fill: "#FFCB00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.88216 31.3239C2.38635 32.0407 1.40077 32.2194 0.68325 31.7255C-0.0362847 31.2316 -0.215665 30.2498 0.280149 29.5351C0.30232 29.5049 7.75968 18.6031 12.2583 23.8271C13.5422 25.3189 14.437 26.2103 14.957 26.2223C15.3279 26.2304 15.8419 25.4674 16.64 23.6846C17.8211 21.0505 18.8067 19.0347 19.9394 18.0288C21.7473 16.4227 23.4262 16.6676 25.2946 19.5306C26.0826 20.7393 27.4632 20.4481 29.0736 19.4041C32.1977 17.3804 35.9223 12.9293 38.9274 9.33545C40.3403 7.64495 41.602 6.13716 42.5997 5.11322C43.2084 4.48883 44.2101 4.47477 44.8369 5.08311C45.4637 5.68944 45.4778 6.68727 44.8671 7.31167C43.9138 8.28943 42.7085 9.73297 41.3561 11.3472C38.2099 15.1096 34.3119 19.7695 30.7949 22.0463C27.6124 24.1082 24.7081 24.4134 22.6401 21.2472C22.225 20.6108 22.0577 20.3739 22.0436 20.3859C21.3543 20.9983 20.54 22.7028 19.5242 24.9675C18.1274 28.0855 16.6984 29.4106 14.8905 29.3704C13.2318 29.3323 11.7101 28.0373 9.84976 25.877C8.05798 23.797 2.89224 31.3038 2.87813 31.3259",
    fill: "#1D1D1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniLogo);
export default __webpack_public_path__ + "static/media/mini-logo.aadbc8578022adec38fb8cb65b56f463.svg";
export { ForwardRef as ReactComponent };